module.exports = __webpack_public_path__ + "static/img/bg-es.a1748ec7.png";